"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/page-header/style");
var _pageHeader = _interopRequireDefault(require("antd/lib/page-header"));
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/tabs/style");
var _tabs = _interopRequireDefault(require("antd/lib/tabs"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
var _GroupInfo = _interopRequireDefault(require("./GroupInfo"));
var _SessionList = _interopRequireDefault(require("./SessionList"));
var _AddSessionModal = _interopRequireDefault(require("../AddSession/AddSessionModal"));
var _GroupReviews = _interopRequireDefault(require("./GroupReviews"));
var _RelatedGroups = _interopRequireDefault(require("./RelatedGroups"));
require("./GroupInfoLayout.less");
var _GroupTopics = _interopRequireDefault(require("./GroupTopics"));
var _excluded = ["onSessionAdd", "onShowModal", "selectedSession"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var TabPane = _tabs.default.TabPane;
var GroupInfoLayout = function GroupInfoLayout(props) {
  var activeTabKey = props.activeTabKey,
    clinicians = props.clinicians,
    group = props.group,
    _props$isEditable = props.isEditable,
    isEditable = _props$isEditable === void 0 ? true : _props$isEditable,
    loading = props.loading,
    _props$newSessionProp = props.newSessionProps,
    onSessionAdd = _props$newSessionProp.onSessionAdd,
    onShowModal = _props$newSessionProp.onShowModal,
    selectedSession = _props$newSessionProp.selectedSession,
    newSessionProps = _objectWithoutProperties(_props$newSessionProp, _excluded),
    onGroupUpdate = props.onGroupUpdate,
    onStatusUpdate = props.onStatusUpdate,
    onTabChange = props.onTabChange,
    tableDefinitions = props.tableDefinitions;
  var _useAllowedForRoles = (0, _utils.useAllowedForRoles)([_utils.UserRoles.Admin, _utils.UserRoles.Admin]),
    isAdmin = _useAllowedForRoles.isAllowed;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "wrapper-container group-info-layout no-shadow"
  }, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_tabs.default, {
    defaultActiveKey: activeTabKey,
    onChange: onTabChange
  }, /*#__PURE__*/_react.default.createElement(TabPane, {
    tab: "Group info",
    key: "info"
  }, /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: !group,
    tip: "Loading...",
    size: "large"
  }, group && /*#__PURE__*/_react.default.createElement(_row.default, {
    gutter: 30,
    className: "flex flex-col md:flex-row items-stretch"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    md: 12,
    className: "mb-30"
  }, /*#__PURE__*/_react.default.createElement(_GroupInfo.default, {
    isEditable: isEditable,
    clinicians: clinicians,
    group: group,
    loading: loading,
    onStatusUpdate: onStatusUpdate,
    onSubmit: onGroupUpdate
  }))))), /*#__PURE__*/_react.default.createElement(TabPane, {
    tab: "Sessions",
    key: "sessions"
  }, isEditable && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AddSessionModal.default, _extends({
    isEditable: isEditable,
    onSubmit: onSessionAdd
  }, newSessionProps, {
    group: group,
    session: selectedSession,
    defaultCapacity: group.capacity
  })), /*#__PURE__*/_react.default.createElement(_pageHeader.default, {
    title: null,
    extra: [/*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: onShowModal,
      key: "new"
    }, "Add session")]
  })), /*#__PURE__*/_react.default.createElement(_SessionList.default, {
    data: group.groupSessions || [],
    definitions: tableDefinitions,
    isEditable: isEditable,
    loading: !group
  })), /*#__PURE__*/_react.default.createElement(TabPane, {
    tab: "Group Reviews",
    key: "groupReviews"
  }, /*#__PURE__*/_react.default.createElement(_GroupReviews.default, {
    group: group
  })), isAdmin && /*#__PURE__*/_react.default.createElement(TabPane, {
    tab: "Related Groups",
    key: "relatedGroups"
  }, /*#__PURE__*/_react.default.createElement(_RelatedGroups.default, {
    group: group
  })), isAdmin && /*#__PURE__*/_react.default.createElement(TabPane, {
    tab: "Group Topics",
    key: "groupTopics"
  }, /*#__PURE__*/_react.default.createElement(_GroupTopics.default, {
    group: group
  }))))));
};
GroupInfoLayout.propTypes = {
  activeTabKey: _propTypes.default.string,
  clinicians: _propTypes.default.array,
  group: _propTypes.default.object,
  isEditable: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  onStatusUpdate: _propTypes.default.func,
  onGroupUpdate: _propTypes.default.func,
  onTabChange: _propTypes.default.func,
  tableDefinitions: _propTypes.default.object
};
var _default = GroupInfoLayout;
exports.default = _default;